import * as PIXI from 'pixi.js';
import Config from './Config';

export default class Health extends PIXI.Container {
  constructor() {
    super();

    this.lastLives = Config.PLAYER_LIVES_INITIAL;

    this.sprites = [];

    this.position.set(Config.GAME_WIDTH - 20, 20);
  }

  onResourcesLoaded() {
    this.sprites = Array.from({ length: Config.PLAYER_LIVES_MAX }, (_, spriteIndex) => {
      const sprite = new PIXI.Sprite(PIXI.Loader.shared.resources['life'].texture);

      sprite.anchor.set(1, 0);
      sprite.position.set((spriteIndex * -90), 0);
      sprite.visible = spriteIndex < Config.PLAYER_LIVES_INITIAL;

      return sprite;
    });

    this.addChild(...this.sprites);
  }

  update(dt, [
    background,
    player,
    ground,
    ...treasures
  ], viewport) {}

  setValue(lives) {
    if (this.lastLives === lives) return;

    const actualLives = Math.min(Config.PLAYER_LIVES_MAX, lives);

    this.lastLives = actualLives;
    this.sprites.forEach((sprite, spriteIndex) => {
      sprite.visible = spriteIndex < actualLives;
    });
  }
}
